import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatusViewProps } from "../../../../types";

export const getRegistrationRequirementPayerStatusCell = (
  requirement: IRequirementResponse
): RequirementStatusViewProps => {
  switch (requirement.status) {
    case RequirementStatus.Complete:
      return {
        pill: {
          text: "Complete",
          theme: "success",
          icon: true
        }
      };

    default:
      return {
        pill: {
          theme: "warning",
          text: "Pending",
          icon: true
        }
      };
  }
};
